import { api } from './api';

// GET all ride options (minimal info for table)
export const getRideOptions = () => api.get('/admin/ride-options');

// GET full ride option details
export const getRideOptionDetails = (id: number) => api.get(`/admin/ride-option/${id}`);

// UPDATE ride option (editable fields)
export const updateRideOption = (id: number, data: any) => api.patch(`/admin/ride-option/${id}`, data);

// OPTIONAL: DELETE a ride option (if supported)
export const deleteRideOption = (id: number) => api.delete(`/admin/ride-option/${id}`);

// CREATE a new ride option
export const createRideOption = (data: any) => api.post('/admin/ride-option', data);
